/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { ActiveLabelerHead } from './tableHead';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getActiveLabeler } from '../Store/action';

const DisplayActiveLabeler = () => {
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const {
    displayObj: {
      contactsValue: getContactsList,
      rebateProgramName: getRebateProgramName,
      contactsDropValue: getContactsValue,
      activeLabel: getActiveLabelList,
    },
  } = useSelector((state) => state?.sharedState?.ActiveReducer);

  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [actLabel, setActLabel] = React.useState([]);
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const name = {
    Invoice: {
      Value: 'Invoice Contact for Control',
    },
  };

  const contactType = getContactsValue?.split(' | ');
  const contactShort = contactType[0]?.trim();
  // active labeler api
  React.useEffect(() => {
    setActLabel(getActiveLabelList?.activeLabelersReportVO);
  }, [getActiveLabelList]);

  // pdf header
  const secondInfo = '';
  let thirdInfo = '';

  thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Active Labeler"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Contacts"
                        id="ContactsDisp"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'ContactsDisp' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={
                          getContactsList == 'Invoice'
                            ? name[getContactsList].Value
                            : getContactsValue
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            data-testid="active-labeler"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={actLabel?.map((item) => {
              return {
                ...item,
                zip: item.zip || '',
                phoneNum: item.phoneNum || '',
              };
            })}
            columnDefs={ActiveLabelerHead}
            exportFile
            animateRows
            sideBar={false}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            reportName="Active Labeler Report"
            fileName="ActiveLabelers"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            isScrollOn
            info={{ secondInfo, thirdInfo }}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 18) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayActiveLabeler;
